module.exports = __webpack_public_path__ + "img/integra-isotipo.87316763.svg";